import { render, staticRenderFns } from "./activateCard.vue?vue&type=template&id=b42189c4&scoped=true&"
import script from "./activateCard.vue?vue&type=script&lang=js&"
export * from "./activateCard.vue?vue&type=script&lang=js&"
import style0 from "./activateCard.vue?vue&type=style&index=0&id=b42189c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42189c4",
  null
  
)

export default component.exports